function closeMenu(){
  


  
  var c = $('.menuLink.ON'),
  d = c.attr('href'),
  e = $('#'+d),
  prop2 = e.attr('data-slidefrom'),
  value2 = 0,
  cssProps2 = new Object()
  cssProps2[prop2] = value2


  TweenMax.to(e, .5, {css:cssProps2 ,ease:Circ.easeInOut,onComplete:function(){ 
  $('.menuLink').removeClass('ON')  
  }})

  
}//function closeMenu()



function closeCorners(){
  



  var c = $('.corners a.ON'),
  d = c.attr('href'),
  e = $('#'+d), 
  f = $('.cornerPopOuts section .inner'),
  g = $('.nicescroll-rails')
      

  var prop2 = e.attr('data-slidefrom'),
  value2 = - e.outerHeight(),
  cssProps2 = new Object()
  cssProps2[prop2] = value2


    g.fadeOut(200)
    f.fadeOut(200,function(){
    
    TweenMax.to(e, .5, {css:cssProps2 ,ease:Circ.easeInOut,onComplete:function(){ 
    c.removeClass('ON' , closeMenu())
    }})
    })
 




  
}//function closeMenu()




function setCartHeight(){
  
      //set height of cart
  var cnum = $('#cartPop li').size(),
      cheight = $('#cartPop li').height()
  
  $('#cartPop ul').outerHeight(cheight*3)
  
      
  
}


function openMobMenu(){

   
    var a = $('.top'),
        b = $('.bottom'),
        c = $('.middle'),
        d = $('.menutab'),
        e = $('.mobmenu'),
        f = $('.mainBucket')
  
    TweenMax.to(a, .2, {rotation:45}); 
    TweenMax.to(b, .2, {rotation:-45});  
    TweenMax.to(c, .2, {opacity:0 , marginTop:-3 , marginBottom:-3});
    TweenMax.to(d, .2, {top:"+=5px"});
    TweenMax.to(e, .4, {left:0});
  
   setTimeout(function(){
  f.hide() 
  },500)
  
}
 


function closeMobMenu(){

 
   
    var a = $('.top'),
        b = $('.bottom'),
        c = $('.middle'),
        d = $('.menutab'),
        e = $('.mobmenu'),
        f = $('.mainBucket')
    f.show() 
    TweenMax.to(a, .2, {rotation:0}); 
    TweenMax.to(b, .2, {rotation:0});  
    TweenMax.to(c, .2, {opacity:1 , marginTop:4 , marginBottom:4});
    TweenMax.to(d, .2, {top:"-=5px"});
    TweenMax.to(e, .4, {left:"-100%"});
  setTimeout(function(){
   
  },500)
  
}




$(document).ready(function(){
  
  
 //homeslideshow
  $('.miniSlideshow').cycle({
fx:'scrollHorz',
timeout:2000,
slides:"> a",
prev:".cycle-prev",
next:".cycle-next",
pauseOnHover:true

});
  
  
  
  
  
  
  
  
  $( ".mobmenu ul li" ).has( "section" ).click(function(event){
    
    var t =$(this),
        a = $( ".mobmenu ul li" )
    
    if(t.hasClass('ON')){
    t.removeClass('ON').find('section').slideUp(200)
    }else{
    a.removeClass('ON').find('section').slideUp(200)  
    t.addClass('ON').find('section').slideDown(200)
    }
    
    
  });
  
      
  //open mob menu
  $('.menutab').click(function(event){
    event.preventDefault()
    
    var t = $(this)
    
    if(t.hasClass('ON')){
     t.removeClass('ON')
     closeMobMenu()
       
       }else{
    t.addClass('ON')  
    openMobMenu()
    
      }
    
  });//menutab

  
  
   
      //set height of panel 
      $('.infoPanelBucket').css('min-height',$('.infoPanel').height())
      
      //panel controls
      $('.showPanel').click(function(event){
        
        event.preventDefault()
        
        var t = $(this),
            a = t.attr('data-reveal'),
            b = $('#'+a),
            c = $('.infoPanel'),
            d = $('.showPanel')
        
        if(t.hasClass('ON')){
          
           }else{
           c.hide()
           b.show()
           d.removeClass('ON')
           t.addClass('ON')
           }
        
      });
  
  //productZoom
$('.productZoom').cycle({
fx:'scrollHorz',
timeout:0,
slides:"> section",
prev:".prev",
next:".next",
});
  
  
  
  $('.productImages').click(function(event){
  event.preventDefault()
  $('.productZoom').fadeIn(200)    
  });
  
  $('.productZoom section').click(function(){
  $('.productZoom').fadeOut(200) 
  });
  
  
  
  
  
  //sexy scroll bars.
   
  $("#cartPop ul").niceScroll({cursorborder:"none",cursorcolor:"#ecf1f2",autohidemode:false,background:"transparent",cursorwidth:9,zindex:9999,});
  
  
  
  //setheight of cart
  
  $('#cartPop .table').height($(window).height()-66)

//SlideMenus
  $('.menuLink').click(function(event){
  event.preventDefault()
  
  var t = $(this),
  a = t.attr('href'),
  b = $('#'+a),
  c = $('.menuLink.ON'),
  d = c.attr('href'),
  e = $('#'+d), 
      
  prop = b.attr('data-slidefrom'),
  value = 33,
  cssProps = new Object()
  cssProps[prop] = value;
  
  var propON = b.attr('data-slidefrom'),
  cssPropsON = new Object()
  cssPropsON[propON] = 0;  
    
  var prop2 = e.attr('data-slidefrom'),
  value2 = 0,
  cssProps2 = new Object()
  cssProps2[prop2] = value2

  if(t.hasClass('ON')){
  TweenMax.to(b, .2, {css:cssPropsON ,ease:Circ.easeInOut});
  t.removeClass('ON')
  }else{
    TweenMax.to(e, .2, {css:cssProps2 ,ease:Circ.easeInOut,onComplete:function(){ 
  TweenMax.to(b, .2, {css:cssProps ,ease:Circ.easeInOut,onComplete:function(){
  c.removeClass('ON')
  t.addClass('ON')
  }
  })}}); 
    
  }
  
  });//menuLink
  

//corners
$('.corners a').click(function(event){
event.preventDefault()

 var t = $(this),
  a = t.attr('href'),
  b = $('#'+a),
  c = $('.corners a.ON'),
  d = c.attr('href'),
  e = $('#'+d), 
  f = $('.cornerPopOuts section .inner'),
     g = $('.nicescroll-rails')
      
  prop = b.attr('data-slidefrom'),
  value = 33,
  cssProps = new Object()
  cssProps[prop] = value;
  
  var propON = b.attr('data-slidefrom'),
  cssPropsON = new Object()
  cssPropsON[propON] = - b.outerHeight();  
    
  var prop2 = e.attr('data-slidefrom'),
  value2 = - e.outerHeight(),
  cssProps2 = new Object()
  cssProps2[prop2] = value2

  if(t.hasClass('ON')){
    g.fadeOut(200)
    f.fadeOut(200,function(){
  TweenMax.to(b, .2, {css:cssPropsON ,ease:Circ.easeInOut});
  t.removeClass('ON')
    })
  }else{
  g.fadeOut(200)
  f.fadeOut(200,function(){
  TweenMax.to(e, .2, {css:cssProps2 ,ease:Circ.easeInOut,onComplete:function(){ 
  TweenMax.to(b, .2, {css:cssProps ,ease:Circ.easeInOut,onComplete:function(){
  c.removeClass('ON')
  t.addClass('ON')
  f.fadeIn(200)
  g.fadeIn(200)
  $('#searchPop form input').focus();
  $("#cartPop ul").getNiceScroll().resize();
    
  }
  })}}); 
  })
  }


});//corners
  
  
  
  
    //PAGE OUTS   
    
    $('a[href*="/"]').click(function(event) {
      if($(this).hasClass('nolink')){
      }else{
    event.preventDefault();
    var linkto = $(this).attr('href')
      
   
      
    setTimeout(function() {
    
   
    if ($(".ON").length > 0){
    var tmt = 800 
    }else{
    var tmt = 0   
    }
  
     
      if ($('.corners a.ON').size()>0){
      closeCorners ()
      tmt = 1500
      }else{
      closeMenu()  
      }
     
     
      
      setTimeout(function() {
$('.mainBucket').animate({opacity:'0'},400,function(){ window.location = linkto;})
    }, tmt);
        
        
    }, 400); 
      }
    });///END PAGEOUTS           
      
  
  
  

  
});//DOC


$(window).load(function(){
  
  
   

  //pageIns
  $('.mainBucket').animate({opacity:'1'},800)
 
   
});//load



$(window).resize(function(){
  
 //setheight of cart
$('#cartPop .table').height($(window).height()-66)
closeMenu()
closeCorners()
closeMobMenu()

});//load
